import { CARDS } from "/src/content/cards.ts";
import { ORGANIZATIONS, ORG_REWARD_POOL } from "/src/content/organizations.ts";
import { REWARD_POOLS } from "/src/content/rewardPools.ts";
import { CARD_ART } from "/src/components/CardView.tsx";
import { cardFrameClass, cardKindLabel } from "/src/components/cardFrame.ts";
import { cardsForPoolSize, flattenPool } from "/src/features/stageEditor/poolCards.ts";

const SIZES = [
  ["small", "小規模"],
  ["medium", "中規模"],
  ["large", "大規模"],
];

const selected = {
  small: new Set(flattenPool(REWARD_POOLS.small)),
  medium: new Set(flattenPool(REWARD_POOLS.medium)),
  large: new Set(flattenPool(REWARD_POOLS.large)),
};

const selectedOrgs = new Set(ORG_REWARD_POOL);

export function snapshotRewards() {
  return {
    small: [...selected.small],
    medium: [...selected.medium],
    large: [...selected.large],
    orgs: [...selectedOrgs],
  };
}

export function applyRewards(rewards) {
  selected.small = new Set(rewards?.small ?? flattenPool(REWARD_POOLS.small));
  selected.medium = new Set(rewards?.medium ?? flattenPool(REWARD_POOLS.medium));
  selected.large = new Set(rewards?.large ?? flattenPool(REWARD_POOLS.large));
  selectedOrgs.clear();
  for (const id of rewards?.orgs ?? ORG_REWARD_POOL) selectedOrgs.add(id);
}

function renderPick(card, size) {
  const on = selected[size].has(card.id);
  const art = CARD_ART[card.id];
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = `editor-pick${on ? " is-on" : ""}`;
  const face = document.createElement("span");
  face.className = `card ${cardFrameClass(card)}${art ? " has-art" : " is-text-only"}`;
  face.innerHTML = art
    ? `<img class="card-art" src="${art}" alt="" draggable="false">`
    : `<strong>${card.name}</strong>`;
  const body = document.createElement("span");
  body.className = "editor-pick-body";
  body.innerHTML = `<b>${card.name}</b><small>${cardKindLabel(card)}</small><p>${card.text}</p>`;
  btn.append(face, body);
  btn.addEventListener("click", () => {
    if (selected[size].has(card.id)) selected[size].delete(card.id);
    else selected[size].add(card.id);
    renderRewardPools();
  });
  return btn;
}

export function renderRewardPools() {
  const root = document.getElementById("reward-pools");
  root.replaceChildren();
  for (const [size, label] of SIZES) {
    const block = document.createElement("div");
    block.className = "pool-block";
    block.innerHTML = `<h3>${label}</h3>`;
    const list = document.createElement("div");
    list.className = "editor-reward-list";
    for (const card of cardsForPoolSize(Object.values(CARDS), size)) {
      list.appendChild(renderPick(card, size));
    }
    block.appendChild(list);
    root.appendChild(block);
  }
  const orgs = document.createElement("div");
  orgs.className = "pool-block";
  orgs.innerHTML = "<h3>組織基盤プール</h3>";
  const orgList = document.createElement("div");
  orgList.className = "editor-reward-list";
  for (const id of ORG_REWARD_POOL) {
    const org = ORGANIZATIONS[id];
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `editor-pick${selectedOrgs.has(id) ? " is-on" : ""}`;
    btn.innerHTML = `<img class="editor-pick-icon" src="/icon-relic-v2.png" alt=""><span class="editor-pick-body"><b>${org.name}</b><small>組織基盤</small><p>${org.text}</p></span>`;
    btn.addEventListener("click", () => {
      if (selectedOrgs.has(id)) selectedOrgs.delete(id);
      else selectedOrgs.add(id);
      renderRewardPools();
    });
    orgList.appendChild(btn);
  }
  orgs.appendChild(orgList);
  root.appendChild(orgs);
}
